import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import SpinnerIcon from './SpinnerIcon'

const Button = forwardRef(
  ({ children, loading, disabled, className, style, textColor, loadingColor, ...rest }, ref) => (
    <button
      ref={ref}
      disabled={disabled || loading}
      className={classnames(
        'flex justify-center items-center form-button px-5 py-3 font-bold rounded-lg outline-none focus:ring focus:ring-opacity-50 hover:opacity-90 disabled:opacity-60 disabled:cursor-not-allowed',
        className,
        textColor
      )}
      style={{
        ...style,
      }}
      {...rest}
    >
      {loading && (
        <SpinnerIcon className={classnames('animate-spin -ml-1 mr-3 h-5 w-5', loadingColor)} />
      )}
      {children}
    </button>
  )
)

Button.propTypes = {
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
}

Button.defaultProps = {
  loading: false,
  disabled: false,
  textColor: 'text-white',
  loadingColor: 'text-white',
}

export default Button
